import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useQuery } from '@apollo/react-hooks';
import { VENDOR_QUERY } from 'const/queries';

export function VendorSelector({ className, onChange }) {
    const [open, setOpen] = React.useState(false);

    const [query, setQuery] = React.useState('');
    const { loading, data } = useQuery(VENDOR_QUERY, {
        variables: {
            query: query,
            first: 10,
        },
    });

    const handleQueryChange = event => {
        setQuery(event.target.value);
    };

    const handleValueChange = (event, value) => {
        onChange(value);
    };

    return (
        <Autocomplete
            onChange={handleValueChange}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.id.toString() === value.id.toString()}
            getOptionLabel={option => option.name}
            options={data ? data.appVendorSearch.edges.map(edge => edge.node) : []}
            loading={loading}
            renderInput={params => (
                <TextField
                    {...params}
                    label="Vendor"
                    variant="outlined"
                    onChange={handleQueryChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        ...params.InputProps,
                        className: className,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}
